<mat-toolbar>
  <div class="wrapper">
    <ng-content></ng-content>
  </div>
</mat-toolbar>
